import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

Swiper.use([Navigation, Pagination, Autoplay]);

const swiper = new Swiper('.content-carousel-inner', {
  slidesPerView: 1,
  spaceBetween: 30,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  speed: 750,
  loop: true,
  autoplay: { 
    delay: 4000
  },
  keyboard: {
    enabled: true,
  }
});